import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@revvsales/components";

// action imports
import { getAssetStatusListAction } from "../../../actions/AssetActions/assetActions";
import { updateDocumentStatusAction } from "../../../actions/DocumentActions/index";
// internal imports
import { OppoUtils, GlobalUtils, AmplitudeUtils } from "../../../utils";
import { EVENTS } from "../../../constants";

// destructuring
const { getDocStatusClassName } = OppoUtils;
const { amplitudeLogEvent } = AmplitudeUtils;

const { truncateString } = GlobalUtils;
const ENTER_KEY = 13;

class StatusDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cursor: 0,
      showMenu: false,
    };
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
    const { assetStatusList, getAssetStatusList } = this.props;
    if (assetStatusList && !assetStatusList.length) {
      getAssetStatusList()
        .then()
        .catch();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  handleKeyDown = e => {
    const { cursor } = this.state;
    // arrow up/down button should select next/previous list element
    if (e.keyCode === 38 && cursor > 0) {
      this.setState(prevState => ({
        cursor: prevState.cursor - 1,
      }));
    } else if (
      e.keyCode === 40 &&
      cursor < this.props.assetStatusList.length - 1
    ) {
      this.setState(prevState => ({
        cursor: prevState.cursor + 1,
      }));
    }

    if (e.keyCode === ENTER_KEY) {
      this.changeDocumentStatus(this.props.assetStatusList[cursor]);
    }
  };

  toggleMenu = () => {
    const { showMenu } = this.state;
    this.setState({
      showMenu: !showMenu,
      cursor: 0,
    });
  };

  handleClickOutside = event => {
    if (
      this.wrapperRef &&
      event.target &&
      event.target.dataset &&
      this.wrapperRef.id !== event.target.dataset.id &&
      !this.wrapperRef.contains(event.target)
    ) {
      this.setState({ showMenu: false });
    }
  };

  setWrapperRef = node => {
    this.wrapperRef = node;
  };

  changeDocumentStatus = item => {
    amplitudeLogEvent(EVENTS.EVENT_NAMES.STATUS_CHANGED, {
      initiatedFrom: this.props.source,
      oldStatus: this.props.currentStatus ? this.props.currentStatus.name : "",
      newStatus: item.name,
      documentID: this.props.docId,
      tag: this.props.currentTag ? this.props.currentTag.name : "",
    });
    this.props.updateDocumentStatus(this.props.docId, item);
    this.toggleMenu();
  };

  render() {
    const { currentStatus } = this.props;
    const { showMenu, cursor } = this.state;
    const { assetStatusList } = this.props;
    return (
      <div className="topbar-rightpane">
        <div
          id="dropdownid"
          ref={this.setWrapperRef}
          className="statusdropdown-wrapper">
          <div
            onClick={this.toggleMenu}
            onKeyPress={() => {}}
            onKeyDown={e => this.handleKeyDown(e)}
            data-id="dropdownid"
            role="button"
            tabIndex="0"
            className="statusdropdown-status">
            {currentStatus ? (
              <div
                style={{
                  backgroundColor: currentStatus.color,
                }}
                className="status-color-container selected-status"
              />
            ) : (
              <span
                className={`statusdropdown-status-icon assetitem-${getDocStatusClassName(
                  "DRAFT",
                )} `}
              />
            )}
            <div>
              {currentStatus && currentStatus.name
                ? truncateString(currentStatus.name, 24, true)
                : "Draft"}
            </div>
            <i className={`asset-angle-down ${showMenu ? "show-dd-menu" : ""}`}>
              <FontAwesomeIcon icon={["far", "angle-down"]} />
            </i>
          </div>

          <div
            className={`statusdropdown-menu ${
              showMenu ? "show-dropdown-menu" : ""
            }`}>
            <ul className="statusdropdown-list">
              {assetStatusList &&
                assetStatusList.map((item, i) => (
                  <div
                    onClick={() => this.changeDocumentStatus(item)}
                    onKeyDown={e => this.handleKeyDown(e)}
                    role="button"
                    tabIndex="0"
                    className="statusdropdown-item">
                    <li
                      key={`${item}status_doc_list`}
                      className={cursor === i ? "activedropdownitem" : null}>
                      <div
                        style={{ backgroundColor: item.color }}
                        className="status-color-container"
                      />
                      <div>{item.name}</div>
                    </li>
                  </div>
                ))}
            </ul>
          </div>
        </div>

        <div className="topbar-help">
          <Tooltip
            placement="bottom"
            overlay="Help"
            align={{
              offset: [0, -6],
            }}>
            <a
              data-test="navbar-knowledgebase"
              href={`${
                process.env.REACT_APP_HELP_JUICE_URL
              }/docs/working-with-document-editor`}
              target="_blank"
              rel="noopener nofollow noreferrer"
              onClick={this._handleView}>
              <i className="i-kb">
                <FontAwesomeIcon icon={["far", "question-circle"]} />
              </i>
            </a>
          </Tooltip>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ AssetStore: { assetStatusList } }) => ({
  assetStatusList,
});

const mapDispatchToProps = {
  updateDocumentStatus: updateDocumentStatusAction,
  getAssetStatusList: getAssetStatusListAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StatusDropdown);



// WEBPACK FOOTER //
// ./src/components/QuotationTopbar/StatusDropdown/index.js